import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27f3f8e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_table_box" }
const _hoisted_2 = { class: "table_wrapper" }
const _hoisted_3 = { class: "sort_table table tablesorter" }
const _hoisted_4 = { class: "thead-light" }
const _hoisted_5 = { style: {"width":"150px","padding-left":"10px","text-align":"center"} }
const _hoisted_6 = { style: {"width":"210px"} }
const _hoisted_7 = { style: {"width":"250px"} }
const _hoisted_8 = { style: {"width":"120px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"30px"} }, null, -1))
const _hoisted_10 = { style: {"width":"100px"} }
const _hoisted_11 = { class: "table_date" }
const _hoisted_12 = { style: {"width":"210px"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "table-desc" }
const _hoisted_15 = { class: "destination" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "table-desc" }
const _hoisted_18 = { class: "destination" }
const _hoisted_19 = { class: "destination" }
const _hoisted_20 = { class: "destination" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-desc" }, null, -1))
const _hoisted_23 = { class: "destination" }
const _hoisted_24 = {
  key: 0,
  class: "destination"
}
const _hoisted_25 = {
  key: 1,
  class: "to"
}
const _hoisted_26 = { class: "table-desc" }
const _hoisted_27 = { class: "destination" }
const _hoisted_28 = { class: "destination" }
const _hoisted_29 = { style: {"width":"250px"} }
const _hoisted_30 = { class: "explanation" }
const _hoisted_31 = { style: {"width":"120px"} }
const _hoisted_32 = { class: "balance_sum" }
const _hoisted_33 = { class: "balance_sum" }
const _hoisted_34 = { style: {"width":"30px"} }
const _hoisted_35 = {
  key: 0,
  class: "downloadInfo"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_icon_svg = _resolveComponent("download-icon-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("DateTime")), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$localization.getTranslate("PayerBeneficiary")), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$localization.getTranslate("PurposePayment")), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$localization.getTranslate("Amount")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$localization.getTranslate("Status")), 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions.filter((i) => i.Status !== 2), (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(item.Date), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(["from-to", { reverse: item.Amount > 0 }])
                }, [
                  (_ctx.isIncomingAcquiring(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$localization.getTranslate("Beneficiary")) + ": ", 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getPayeeName(item)), 1)
                          ])
                        ])
                      ]))
                    : (_ctx.isOutgoingAcquiring(item))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$localization.getTranslate("Beneficiary")) + ": ", 1),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(item.AcquiringPayout.ToFirstName) + " " + _toDisplayString(item.AcquiringPayout.ToLastName), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(item.AcquiringPayout.ToCardNumber), 1)
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (!_ctx.isIntenal(item) || item.Amount > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getPayerName(item)), 1)
                                  ])
                                ]),
                                (_ctx.paymentsType !== 4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getPayerIban(item)), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (
											_ctx.isCryptPayout(item) ||
											_ctx.isCardPayout(item) ||
											_ctx.isSepa(item) ||
											_ctx.isSwift(item) ||
											(_ctx.isIntenal(item) && item.Amount < 0)
										)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$localization.getTranslate("Beneficiary")) + ": ", 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getPayeeName(item)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getPayeeIban(item)), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                ], 2)
              ]),
              _createElementVNode("td", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", null, _toDisplayString(item.Description), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
										minus: item.Amount < 0,
										plus: item.Amount > 0,
									})
                  }, _toDisplayString(item.Amount) + " " + _toDisplayString(item.CurrencyName), 3)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
										minus: item.Status == 2,
										plus: item.Status == 1,
									})
                  }, [
                    (item.Status == 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("InProcess")), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (item.Status == 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Completed")), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (item.Status == 2)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Canceled")), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (item.Status == 4)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("OnCheck")), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]),
              _createElementVNode("td", _hoisted_34, [
                ([0, 1, 2, 3, 4].includes(item.Type) && item.Status == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("span", null, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.downloadInfo(item))
                        }, [
                          _createElementVNode("span", _hoisted_37, [
                            _createVNode(_component_download_icon_svg)
                          ])
                        ], 8, _hoisted_36)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}